"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadHttp = exports.streamUpload = exports.streamDownload = exports.initiateTransfer = exports.getTransfers = exports.getRemoteFiles = exports.downloadHttp = exports.createTransferSpec = void 0;
/* Package Imports */
var axios_1 = __importDefault(require("axios"));
/* Blast Imports */
var config_1 = require("@app/shared/config");
var log_1 = __importDefault(require("@app/shared/log"));
/* Transfer API methods - BEGIN */
// Create the transfer specification for a package, using the provided parameters
var createTransferSpec = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/transfers",
                    method: 'post',
                    data: params
                })];
            case 1:
                response = _a.sent();
                if (response.data) {
                    return [2 /*return*/, response.data];
                }
                else {
                    throw new Error('unable to generate transfer spec');
                }
                return [2 /*return*/];
        }
    });
}); };
exports.createTransferSpec = createTransferSpec;
// Starts the download of a specific package, using the provided package id, w/o the Aspera plugin
var downloadHttp = function (packageId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.post(config_1.Config.UI_SERVICES_URL + "/transfers/pluginless/download/" + packageId)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.downloadHttp = downloadHttp;
// Retrieve the files for a specific shared folder, using the provided shared folder id
var getRemoteFiles = function (sourceId, params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios_1.default.post(config_1.Config.UI_SERVICES_URL + "/transfers/remote-sources/" + sourceId, params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_1 = _a.sent();
                log_1.default.error("Error with retrieving remote files: " + JSON.stringify(error_1));
                throw new Error('unable to retrieve files');
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getRemoteFiles = getRemoteFiles;
// Get transfer information for all active uploads that don't use the Aspera plugin
var getTransfers = function (minCreationDate) { return __awaiter(void 0, void 0, void 0, function () {
    var params, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {
                    minCreationDate: minCreationDate
                };
                return [4 /*yield*/, axios_1.default({
                        url: config_1.Config.UI_SERVICES_URL + "/transfers/pluginless/upload",
                        method: 'get',
                        params: params
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getTransfers = getTransfers;
// Initiates the transfer for a remote package, using the provided parameters
var initiateTransfer = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/transfers/" + params.packageId,
                    method: 'post',
                    data: params
                })];
            case 1:
                response = _a.sent();
                if (response.data) {
                    return [2 /*return*/, response.data];
                }
                else {
                    throw new Error("unable to initiate transfer for package " + params.packageId);
                }
                return [2 /*return*/];
        }
    });
}); };
exports.initiateTransfer = initiateTransfer;
// Start the download of files for a specific package, using the package id, w/o using the Aspera plugin
var streamDownload = function (packageId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, url, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/transfers/pluginless/download/" + packageId + "/stream")];
            case 1:
                response = _a.sent();
                url = response.data.downloadUrl;
                window.location = url;
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                log_1.default.error("Error with stream download: " + JSON.stringify(error_2));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.streamDownload = streamDownload;
// Start the upload of the files, for a package, w/o the Aspera plugin
var streamUpload = function (packageId, files) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = new FormData();
                files.forEach(function (f) { return data.append('packageFile', f); });
                return [4 /*yield*/, axios_1.default({
                        url: config_1.Config.UI_SERVICES_URL + "/transfers/pluginless/upload/" + packageId + "/stream",
                        method: 'post',
                        data: data
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.streamUpload = streamUpload;
// Starts the upload of a package w/o the Aspera plugin
var uploadHttp = function (packageId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/transfers/pluginless/upload/" + packageId,
                    method: 'post'
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.uploadHttp = uploadHttp;
/* Transfer API methods - END */
